import type { OfferLabelsTranslation } from '../../offer-labels-content';

export const offerLabels: OfferLabelsTranslation = {
  bestPlaceBadge: 'Tā mātou kōwhiringa',
  bestPriceBadge: 'Utu pai rawa',
  regulatedNotice: {
    prescriptionOnly: 'Mā te whakahau rongoā anake',
    professionalUse: 'Mō te whakamahinga ngaio',
    fromVeterinarian: 'E wātea ana i tō rata kararehe',
    fromPharmacist: 'E wātea ana i tētahi kai-rongoā',
    noOnlinePurchase: 'Kāore e hokona ā-ipurangi',
    professionalSupply: 'Ka hokona mā ngā kaiwhakarato ngaio',
    whyNoLink: 'Ka arotakea e mātou tēnei hua, engari kāore mātou e tuku hononga ki a ia.',
  },
};
